import React from 'react';
import { suitesData, heroImages } from '../../data/mock';
import { Check } from 'lucide-react';

const Suites = () => {
  return (
    <section id="suites" className="section-padding bg-[#E8EFEC]">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-normal text-[#1E2E2A] mb-8 tracking-wider">
              {suitesData.title}
            </h2>
            
            <p className="text-lg text-[#1E2E2A]/70 leading-relaxed mb-10">
              {suitesData.intro}
            </p>

            <ul className="space-y-4">
              {suitesData.bullets.map((item, index) => (
                <li key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-6 h-6 rounded-md bg-[#3E6259]/10 flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-[#3E6259]" />
                  </div>
                  <span className="text-[#1E2E2A] text-lg">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src={heroImages.workspace}
                alt="Private suite"
                className="w-full h-[400px] object-cover"
              />
            </div>
            <div className="absolute -z-10 -bottom-4 -right-4 w-full h-full bg-[#3E6259]/10 rounded-2xl" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Suites;
